import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Link } from 'react-router-dom';
import { api } from '../../services/api';
import { useContentList } from '../../hooks/useContent';
import { getImageUrl } from '../../utils/imageUrl';
import { formatTourDate } from '../../utils/text';
import { useAdaptiveImageTone } from '../../hooks/useAdaptiveImageTone';
import { useSiteContent, sectionField } from '../../hooks/useSiteContent';

function TourOne() {
  const { items: tours, loading, error } = useContentList(
    () => api.getTours({ per_page: 12 }),
    []
  );
  const { content } = useSiteContent('home');
  const subtitle = sectionField(content, 'tours', 'subtitle', 'Best Place For You');
  const title = sectionField(content, 'tours', 'title', 'Most Popular Tour');
  const intro = sectionField(content, 'tours', 'intro', 'Explore our latest tour packages and book your next adventure with Travel With Ammar.');
  const bgImage = sectionField(content, 'tours', 'bg_image', '/assets/img/bg/tour_bg_1.jpg');
  const bookCta = sectionField(content, 'tours', 'book_cta', 'Book Now');
  const palette = useAdaptiveImageTone(bgImage);

  if (!loading && !error && !tours.length) {
    return null;
  }

  return (
    <section
      className={`tour-area position-relative bg-top-center overflow-hidden space bg-no-repeat twa-photo-section twa-banner-tone twa-banner-tone--${palette.tone}`}
      id="service-sec"
      style={{
        backgroundImage: `url(${bgImage})`,
        '--twa-banner-text': palette.textColor,
        '--twa-banner-muted': palette.mutedColor,
        '--twa-banner-accent': palette.accentColor,
        '--twa-banner-shadow': palette.shadow,
        '--twa-section-overlay': palette.sectionOverlay || palette.overlay,
      }}
    >
      <div
        className="twa-banner-overlay"
        style={{ background: palette.sectionOverlay || palette.overlay }}
        aria-hidden="true"
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-6 offset-lg-3">
            <div className="title-area text-center">
              <span className="sub-title">{subtitle}</span>
              <h2 className="sec-title">{title}</h2>
              <p className="sec-text">{intro}</p>
            </div>
          </div>
        </div>

        {loading && <p className="text-center">Loading tours...</p>}
        {error && <p className="text-center text-danger">{error}</p>}

        {!loading && !error && (
          <div className="slider-area tour-slider">
            <Swiper
              breakpoints={{
                0: { slidesPerView: 1 },
                576: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                992: { slidesPerView: 2 },
                1200: { slidesPerView: 3 },
                1300: { slidesPerView: 4 },
              }}
              spaceBetween={24}
              grabCursor={true}
              className="swiper th-slider has-shadow slider-drag-wrap"
            >
              {tours.map((tour) => (
                <SwiperSlide key={tour.id}>
                  <div className="tour-box th-ani gsap-cursor">
                    <div className="tour-box_img global-img">
                      <img
                        src={getImageUrl(tour.image, 'tour')}
                        alt={tour.title}
                      />
                    </div>
                    <div className="tour-content">
                      <h3 className="box-title">
                        <Link to={`/tour/${tour.id}`}>{tour.title}</Link>
                      </h3>
                      <div className="tour-rating">
                        <div className="star-rating" role="img" aria-label="Rated 5.00 out of 5">
                          <span style={{ width: '100%' }}>
                            Rated <strong className="rating">5.00</strong> out of 5 based on{' '}
                            <span className="rating">4.8</span> (4.8 Rating)
                          </span>
                        </div>
                        <Link to={`/tour/${tour.id}`} className="woocommerce-review-link">
                          <span className="count">4.8</span> Rating)
                        </Link>
                      </div>
                      <h4 className="tour-box_price">
                        <span className="currency">{tour.price}</span>
                        {tour.has_packages || (tour.packages && tour.packages.length > 0) || (tour.price && String(tour.price).includes('–'))
                          ? null
                          : '/Person'}
                      </h4>
                      {tour.next_date && (
                        <p className="twa-tour-card-slots mb-2">
                          {formatTourDate(tour.next_date)}
                          {tour.available_slots != null && (
                            <span>
                              {' · '}
                              {tour.available_slots > 0 ? `${tour.available_slots} slots left` : 'Sold out'}
                            </span>
                          )}
                        </p>
                      )}
                      <div className="tour-action">
                        <span>
                          <i className="fa-light fa-clock" />7 Days
                        </span>
                        <Link to={`/tour/${tour.id}#book`} className="th-btn style4 th-icon">
                          {bookCta}
                        </Link>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </div>
    </section>
  );
}

export default TourOne;
